// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"bd88aa65","100":"f082e332","359":"aad257fd","581":"6e49332a","587":"c15f244a","601":"ba6b3e97","656":"66ac8b67","798":"0bda94a9","931":"853a2c2a","981":"37bfc8ff","993":"9dff7ea6"}[chunkId] + ".chunk.js";
};